import { render, staticRenderFns } from "./CurrentConfiguration.vue?vue&type=template&id=59f07684&scoped=true&"
import script from "./CurrentConfiguration.vue?vue&type=script&lang=js&"
export * from "./CurrentConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CurrentConfiguration.vue?vue&type=style&index=0&id=59f07684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f07684",
  null
  
)

export default component.exports